import { render, staticRenderFns } from "./New.vue?vue&type=template&id=0e24efe8&scoped=true&"
import script from "./New.vue?vue&type=script&lang=js&"
export * from "./New.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/content.scss?vue&type=style&index=0&id=0e24efe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e24efe8",
  null
  
)

export default component.exports